import { t } from '@trimble/i18n';
import type { TreeItemContextMenuOption } from '@trimble/ui-components/solidjs';
import type {
  AddToWorkspaceMenuOptionInput,
  AddToWorkspaceMenuSource,
} from './create-add-to-workspace-menu-option.types';

export type {
  AddToWorkspaceMenuOptionInput,
  AddToWorkspaceMenuSource,
} from './create-add-to-workspace-menu-option.types';

export function createAddToWorkspaceMenuOption(
  input: AddToWorkspaceMenuOptionInput
): TreeItemContextMenuOption | undefined {
  const workspaceId = input.activeWorkspaceId;
  if (workspaceId === undefined || !input.referencesLoaded) {
    return undefined;
  }

  if (input.isAlreadySaved()) {
    return {
      text: t('mobileMapping.fxWorkspace.removeFromWorkspace'),
      onClick: () => {
        input.removeReference(workspaceId, input.refTrn);
      },
    };
  }

  return {
    text: t('mobileMapping.fxWorkspace.addToWorkspace'),
    onClick: () => {
      input.addReference(workspaceId, input.refTrn, input.referenceType);
    },
  };
}

export function createRowAddToWorkspaceMenuOption(
  source: AddToWorkspaceMenuSource,
  refTrn: string,
  referenceType: AddToWorkspaceMenuOptionInput['referenceType']
): TreeItemContextMenuOption | undefined {
  const activeWorkspaceId = source.activeWorkspaceId();
  return createAddToWorkspaceMenuOption({
    refTrn,
    referenceType,
    activeWorkspaceId,
    referencesLoaded:
      activeWorkspaceId !== undefined &&
      source.areWorkspaceReferencesLoaded(activeWorkspaceId),
    isAlreadySaved: () => {
      const currentWorkspaceId = source.activeWorkspaceId();
      return (
        currentWorkspaceId !== undefined &&
        source.isReferenceVisible(currentWorkspaceId, refTrn)
      );
    },
    addReference: (workspaceId, referenceTrn, type) => {
      source.addReference(workspaceId, referenceTrn, type);
    },
    removeReference: (workspaceId, referenceTrn) => {
      source.removeReference(workspaceId, referenceTrn);
    },
  });
}
